// tslint:disable:max-line-length
import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { WorkItemModel } from '../../models/work-item';
import { UiStyleService } from '../../services/ui-style.service';

@Component({
  selector: 'e5core-ui-work-item',
  // templateUrl: './components/e5core-ui-work-item.component.html',
  template: `
    <span [ngSwitch]="style.current()">
      <e5core-ui-work-item-box       *ngSwitchCase='0'  [workItem$]='workItem$' [workItem]='workItem'></e5core-ui-work-item-box>
      <e5core-ui-work-item-bootstrap *ngSwitchCase='1'  [workItem$]='workItem$' [workItem]='workItem'></e5core-ui-work-item-bootstrap>
      <e5core-ui-work-item-material  *ngSwitchCase='2'  [workItem$]='workItem$' [workItem]='workItem'></e5core-ui-work-item-material>
    </span>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class E5coreUiWorkItemComponent implements OnInit {

  @Input() workItem$: BehaviorSubject<WorkItemModel> ;
  workItem: WorkItemModel ;

  constructor(public style:UiStyleService, private cd: ChangeDetectorRef ) { }

  ngOnInit() {
    if (this.workItem$ == null) {
      console.error('e5core-ui-work-item [workItem$] must have a BehaviorSubject<WorkItemModel>');
      return ;
    }
    this.workItem$.subscribe(
      n => {
        this.workItem = n ;
        this.cd.markForCheck();
      },
      e => this.workItem = null
    );
  }

}
